import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { principalCountry },
} = loanFormModel;

export class PrincipalCountryValidation implements ValidationSchema {
  public name = principalCountry.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalCountry.requiredErrorMsg,
    value: principalCountry.required,
  };
  public nullable = true;
}
export default new Validation(new PrincipalCountryValidation());
